import stickybits from 'stickybits';
import { isLG } from '../../util/domutils';
// eslint-disable-next-line no-unused-vars
import { functions as headerFunctions } from '../../components/header';

const GLOBALS = {
  STICKY_DESCRIPTION: null,
  STICKY_PRODUCT_SET_IMAGE: null,
};

const SELECTORS = {
  STICKY_DESCRIPTION: '.product-detail__details-section-sticky',
  STICKY_PRODUCT_SET_IMAGE: '.product-set-main-image-sticky',
};

const isProductSet = document.querySelector('.product-set-detail') !== null;

/**
 * Checks whether the passed in parameter is a Stickybits reference
 * and if so, whether the wrapped element is still part of the DOM.
 * Used to determine whether the sticky description needs to be reinitialized
 *
 * @param  {Stickybits?} ref The Stickybits reference to Check
 * @return {boolean}         True if the reference exists and wraps a DOM element
 */
const referenceIsFresh = ref => ref && ref.els[0] && document.body.contains(ref.els[0]);

const initStickyDescriptionObject = () => {
  if (!GLOBALS.STICKY_DESCRIPTION || !referenceIsFresh(GLOBALS.STICKY_DESCRIPTION)
    || !GLOBALS.STICKY_PRODUCT_SET_IMAGE || !referenceIsFresh(GLOBALS.STICKY_PRODUCT_SET_IMAGE)) {
    if (document.querySelector(SELECTORS.STICKY_DESCRIPTION)) {
      const STICKY_DESCRIPTION_OPTIONS = {
        useStickyClasses: true,
        // eslint-disable-next-line max-len
        stickyBitStickyOffset: Math.ceil(window.innerHeight - document.querySelector('.product-detail__details-section-sticky').offsetHeight),
      };
      if (isProductSet) {
        GLOBALS.STICKY_PRODUCT_SET_IMAGE = stickybits(SELECTORS.STICKY_PRODUCT_SET_IMAGE, STICKY_DESCRIPTION_OPTIONS);
      } else {
        GLOBALS.STICKY_DESCRIPTION = stickybits(SELECTORS.STICKY_DESCRIPTION, STICKY_DESCRIPTION_OPTIONS);
      }
    }
  }
};

export default () => {
  if (isLG()
    && (!referenceIsFresh(GLOBALS.STICKY_DESCRIPTION) || !referenceIsFresh(GLOBALS.STICKY_PRODUCT_SET_IMAGE))) {
    initStickyDescriptionObject();
  } else if (referenceIsFresh(GLOBALS.STICKY_DESCRIPTION)) {
    GLOBALS.STICKY_DESCRIPTION.cleanup();
    GLOBALS.STICKY_DESCRIPTION = null;
  } else if (referenceIsFresh(GLOBALS.STICKY_PRODUCT_SET_IMAGE)) {
    GLOBALS.STICKY_PRODUCT_SET_IMAGE.cleanup();
    GLOBALS.STICKY_PRODUCT_SET_IMAGE = null;
  }
};
